import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { selectP360PartnerFlagsState } from 'partner360/features/p360PartnerFlags/selectors/selectP360PartnerFlagsState'

export const selectP360PartnerFlagsIsLoading = createSelector(
  [selectP360PartnerFlagsState],
  ({ requestStatus }) => {
    return requestStatus === RequestStatus.PENDING
  }
)
